export default __webpack_public_path__ + "static/media/delete.24b7b94d.svg";